import { environment, globeConfigs } from './constants';

export const fetchAll = async() => {
    let combined = [];

    for (const domain in globeConfigs) {
        let apiUrl = new URL(globeConfigs[domain].urls[environment]);

        const results = await fetch(apiUrl).then(response => {
            if (response.ok) {
                if (response.status === 204) {
                    return [];
                }

                return response.json();
            }

            throw new Error(response.statusText);
        }).then(response => {
            return response.map(function(record) {
                record.Domain = domain;
                return record;
            });
        });

        combined = [ ...combined, ...results ];
    }
    return combined;
};
